import React, { useRef, useCallback, useState } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import { Formik, Form } from "formik";
import "./little-norway.css";
import ImageUploadBoxMultiple from "../../../../../common/imageUploadBox/image-upload-box-multiple";


const LittleNorway = ({ updateFormData, nextStep, prevStep }) => {
  const webcamRefs = useRef([]); // Array of webcam references
  const fileInputRefs = useRef([]); // Array of file input references
  const [openIndexes, setOpenIndexes] = useState([]); // Array to manage which webcam is open
  const [bedroomImages, setBedroomImages] = useState([]); // Array to store bedroom images
  const [loungeImages, setLoungeImages] = useState([]); // Array to store lounge images
  const [educationImages, setEducationImages] = useState([]); // Array to store education room images

  // Function to capture the image from the webcam for a specific index
  const capture = useCallback((index, setImageFunction) => {
    if (webcamRefs.current[index]) {
      const image = webcamRefs.current[index].getScreenshot();
      setImageFunction((prev) => {
        const updatedImages = [...prev];
        updatedImages[index] = image; // Store the captured image for this index
        return updatedImages;
      });
    } else {
      console.error("Webcam not ready.");
    }
  }, []);

  const handleButtonClick = (index) => {
    fileInputRefs.current[index].click();
  };

  const handleFileChange = (event, index, setImageFunction) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImageFunction((prev) => {
          const updatedImages = [...prev];
          updatedImages[index] = reader.result; // Store the uploaded image for this index
          return updatedImages;
        });
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Box className='norway-container-form'>
      <Box className='top-right-character'>
        <img src='./CYPImages/WormisDryStem.png' alt='Top Right Character' className='top-right-character-image' />
      </Box>

      <Formik
        initialValues={{}}
        onSubmit={(values) => {
          // Include the images for each section into littleNorwayInfo
          const littleNorwayInfo = {
            bedroom: bedroomImages,
            lounge: loungeImages,
            educationRoom: educationImages,
          };

          updateFormData({ littleNorwayInfo });
          nextStep(); // Move to next form
        }}
        validateOnMount={false} // Do not validate on page reload or initial render
        validateOnBlur={true} // Validate on blur (when the user leaves the field)
      >
        {({ handleSubmit }) => (
          <Box mt={8} mb={20}>
            <Form onSubmit={handleSubmit} className='norway-form-container'>
              {/* Form Title */}
              <Typography variant='h4' className='form-title' sx={{ color: "#1976d2", textAlign: "center" }}>
                Little Norway
              </Typography>

              {/* Bedroom Section */}
              <Typography variant='h5' sx={{ color: "#FF5722", textAlign: "center", mt: 4 }}>
                Bedroom
              </Typography>
              <Grid container spacing={3} justifyContent='center' mt={2}>
                {Array.from({ length: 2 }).map((_, index) => (
                  <ImageUploadBoxMultiple
                    key={`bedroom-${index}`}
                    index={index} // Ensure unique index per section
                    imageSrc={bedroomImages[index] || ""}
                    openIndexes={openIndexes}
                    webcamRef={webcamRefs}
                    fileInputRef={fileInputRefs}
                    handleButtonClick={handleButtonClick}
                    handleFileChange={(e) => handleFileChange(e, index, setBedroomImages)}
                    capture={() => capture(index, setBedroomImages)}
                    setOpenIndexes={setOpenIndexes}
                  />
                ))}
              </Grid>

              {/* Lounge Section */}
              <Typography variant='h5' sx={{ color: "#FF5722", textAlign: "center", mt: 4 }}>
                Lounge
              </Typography>
              <Grid container spacing={3} justifyContent='center' mt={2}>
                {Array.from({ length: 2 }).map((_, index) => (
                  <ImageUploadBoxMultiple
                    key={`lounge-${index + 2}`} // Ensure unique key by adding an offset
                    index={index + 2} // Ensure unique index by adding an offset
                    imageSrc={loungeImages[index] || ""}
                    openIndexes={openIndexes}
                    webcamRef={webcamRefs}
                    fileInputRef={fileInputRefs}
                    handleButtonClick={handleButtonClick}
                    handleFileChange={(e) => handleFileChange(e, index, setLoungeImages)}
                    capture={() => capture(index, setLoungeImages)}
                    setOpenIndexes={setOpenIndexes}
                  />
                ))}
              </Grid>

              {/* Education Room Section */}
              <Typography variant='h5' sx={{ color: "#FF5722", textAlign: "center", mt: 4 }}>
                Education Room
              </Typography>
              <Grid container spacing={3} justifyContent='center' mt={2}>
                {Array.from({ length: 2 }).map((_, index) => (
                  <ImageUploadBoxMultiple
                    key={`education-${index + 4}`} // Ensure unique key by adding an offset
                    index={index + 4} // Ensure unique index by adding an offset
                    imageSrc={educationImages[index] || ""}
                    openIndexes={openIndexes}
                    webcamRef={webcamRefs}
                    fileInputRef={fileInputRefs}
                    handleButtonClick={handleButtonClick}
                    handleFileChange={(e) => handleFileChange(e, index, setEducationImages)}
                    capture={() => capture(index, setEducationImages)}
                    setOpenIndexes={setOpenIndexes}
                  />
                ))}
              </Grid>

              {/* Submit Button */}
              <Box mt={3}>
                <Grid container justifyContent='space-between' alignItems='center' mt={2}>
                  <Grid item>
                    <Button type='button' variant='contained' color='primary' onClick={prevStep}>
                      Previous
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button type='submit' variant='contained' color='primary'>
                      Next
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Form>
          </Box>
        )}
      </Formik>
      <Box className='left-bottom-little'>
        <img src='./CYPImages/littleHome.png' alt='left character' className='left-bottom-little-image' />
      </Box>
    </Box>
  );
};

export default LittleNorway;
